import React from 'react'
import AnimationPlayer from '../Animation-Player/AnimationPlayer'
import dataNotfound from "../../Assets/Json/nodata-found-robot-animation.json"
import styled from "@emotion/styled"

export const StyledH2Content = styled("h2")({
    color:"#6665ea",
    marginTop: "30px",
    marginBottom: "-20px",
})

const StyledAnimationContainer = styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",

  });
function DataNotFound({ dataNotFoundMessage }) {
  return (
      <StyledAnimationContainer>
        <StyledH2Content>{ dataNotFoundMessage}</StyledH2Content> 
        <AnimationPlayer animationSrc={dataNotfound} playerHeight='50vh' playerWidth='500px'/>  
    </StyledAnimationContainer>
  )
}

export default DataNotFound